module.exports = __webpack_public_path__ + "static/group5_4-627abab43a59713814a16572e694e17b.webp";